import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const ScheduleResultRow = ({ row }) => (
  <Fragment>
    {`${row.event_name} (doc: ${row.doc_no})`}
    {row.date_filed &&
      <div>Event Filed: {row.date_filed}</div>
    }
    {row.date_due_set &&
      <div>Due / Set: {row.date_due_set}</div>
    }
    {row.date_satisfied &&
      <div>Satisfied: {row.date_satisfied}</div>
    }
    {row.date_terminated &&
      <div>Terminated: {row.date_terminated}</div>
    }
    {row.hearing_judge &&
      <div>Hearing Judge: {row.hearing_judge}</div>
    }
  </Fragment>
);

ScheduleResultRow.propTypes = {
  row: PropTypes.any.isRequired,
};

export default ScheduleResultRow;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/rows/ScheduleResultRow.jsx